var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Toolbar',{attrs:{"value":_vm.value,"fill":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }